import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaRegClock } from "react-icons/fa";
import { FaRegHandshake } from "react-icons/fa6";
import { IoEarOutline } from "react-icons/io5";
import CardSoft from '../ui/CardSoft';

const FeaturedTreatments = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        // Initial check
        handleResize();

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const treatments = [
        {
            title: 'Vaginal Rejuvenation',
            image: 'https://images.unsplash.com/photo-1606902965551-dce093cda6e7?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
            desc: 'Restore the youthfulness and aesthetic appeal to your vagina, with procedures designed specifically for your condition.',
            link: '/services'
        },
        {
            title: 'Labiaplasty',
            image: 'https://images.unsplash.com/photo-1516549655169-df83a0774514?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
            desc: 'Enhance the function and appearance of your vagina, with an efficient, accurate, and world-class procedure that reshapes your Labia.',
            link: '/services'
        },
        {
            title: 'Vaginal Tightening',
            image: 'https://images.unsplash.com/photo-1515377905703-c4788e51af15?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
            desc: 'Get rid of the unwanted changes in your body, with a smoother, tighter, and strengthened the vaginal area, and feel your absolute best.',
            link: '/services'
        }
    ];

    return (
        <section className="section" style={{
            background: 'linear-gradient(135deg, #f5f0ed 0%, #faf8f7 50%, #f0e8e4 100%)',
            position: 'relative',
            overflow: 'hidden'
        }}>
            {/* Decorative background elements */}
            <div style={{
                position: 'absolute',
                top: '-100px',
                right: '-100px',
                width: '300px',
                height: '300px',
                borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(181,131,131,0.1) 0%, transparent 70%)',
                pointerEvents: 'none'
            }}></div>
            <div style={{
                position: 'absolute',
                bottom: '-150px',
                left: '-150px',
                width: '400px',
                height: '400px',
                borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(181,131,131,0.08) 0%, transparent 70%)',
                pointerEvents: 'none'
            }}></div>

            <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                {/* Section Title and Subtitle */}
                <div style={{ textAlign: 'center', maxWidth: '900px', margin: '0 auto 60px' }}>
                    <h2 style={{
                        fontSize: 'clamp(2.5rem, 5vw, 3.5rem)',
                        fontFamily: 'var(--font-heading)',
                        color: 'var(--secondary)',
                        marginBottom: '20px',
                        fontWeight: '700',
                        letterSpacing: '0.5px'
                    }}>
                        Advanced Medical Technology at Nyssa
                    </h2>
                    <p style={{
                        fontSize: '1.15rem',
                        color: 'var(--text-light)',
                        lineHeight: '1.8',
                        maxWidth: '800px',
                        margin: '0 auto'
                    }}>
                        To support accurate diagnosis and safer, more effective treatment, Nyssa uses world class medical technologies that work in harmony with expert clinical judgement keeping safty at its helm.
                    </p>
                </div>

                {/* Image Gallery */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))',
                    gap: isMobile ? '20px' : '30px',
                    maxWidth: '1200px',
                    margin: '0 auto',
                    padding: isMobile ? '0 15px' : '0'
                }}>
                    {[
                        {
                            src: '/jeet.png',
                            name: 'JETT Plasma',
                            description: 'A precision plasma technology used in regenerative and cosmetic gynaecology to support tissue rejuvenation with controlled, targeted treatment.'
                        },
                        {
                            src: '/dioat laser.png',
                            name: 'Diode Laser',
                            description: 'Provides effective, medically guided hair reduction suitable for different skin types, with a focus on safety and consistency.'
                        },
                        {
                            src: '/tesla.png',
                            name: 'Tesla Former Chair',
                            description: 'A non-invasive Functional Magnetic Stimulation (FMS) used for urinary incontinence, pelvic floor weakness, and erectile dysfunction. Helps strengthen pelvic muscles without surgery, injections, or recovery time.'
                        },
                        {
                            src: '/alice bubble.jpg',
                            name: 'Hydra Facial',
                            description: 'A multi-step medical facial treatment that cleanses, exfoliates, hydrates, and nourishes the skin, customised to individual skin needs.'
                        },
                        {
                            src: '/co2laser.jpeg',
                            name: 'CO2 Laser',
                            description: 'Used for advanced dermatological and gynaecological procedures, offering precise treatment with minimal damage to surrounding tissue.'
                        },
                    ].map((equipment, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: index * 0.15 }}
                            whileHover={{ y: -10, transition: { duration: 0.3 } }}
                            style={{
                                borderRadius: '20px',
                                overflow: 'hidden',
                                boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
                                background: '#fff',
                                transition: 'all 0.3s ease',
                                position: 'relative'
                            }}
                        >
                            <div style={{
                                position: 'relative',
                                paddingBottom: '100%',
                                overflow: 'hidden',
                                background: '#fff'
                            }}>
                                <img
                                    src={equipment.src}
                                    alt={equipment.name}
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                        transition: 'transform 0.5s ease'
                                    }}
                                    onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                                    onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                                />

                                {/* Equipment Name - Always Visible */}
                                <div style={{
                                    position: 'absolute',
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
                                    padding: '30px 20px 15px',
                                    zIndex: 1
                                }}>
                                    <h3 style={{
                                        color: '#fff',
                                        fontSize: '1.2rem',
                                        fontWeight: '600',
                                        margin: 0,
                                        fontFamily: 'var(--font-heading)'
                                    }}>
                                        {equipment.name}
                                    </h3>
                                </div>

                                {/* Hover Overlay with Description */}
                                <div
                                    className="equipment-overlay"
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        bottom: 0,
                                        background: 'rgba(181, 131, 131, 0.95)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        padding: '30px',
                                        opacity: 0,
                                        transition: 'opacity 0.4s ease',
                                        zIndex: 2
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.opacity = '1'}
                                    onMouseLeave={(e) => e.currentTarget.style.opacity = '0'}
                                >
                                    <h3 style={{
                                        color: '#fff',
                                        fontSize: '1.4rem',
                                        fontWeight: '700',
                                        marginBottom: '15px',
                                        fontFamily: 'var(--font-heading)',
                                        textAlign: 'center'
                                    }}>
                                        {equipment.name}
                                    </h3>
                                    <p style={{
                                        color: '#fff',
                                        fontSize: '0.95rem',
                                        lineHeight: '1.6',
                                        textAlign: 'center',
                                        margin: 0
                                    }}>
                                        {equipment.description}
                                    </p>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section >
    );
};

export default FeaturedTreatments;
